<template>
	<div></div>
</template>
<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';

export default {

  name: "home",
  components: {
  },

  data() {
    return {        
    };
  },
  updated: function () {
    },
  computed: {    
  },
  methods: 
  {
        
  }
    
};
</script>
